import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrunei = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_663)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0001 23.9983C18.6265 23.9983 23.9983 18.6265 23.9983 12.0001C23.9983 5.37362 18.6265 0.00182724 12.0001 0.00182724C5.37366 0.00182724 0.00186157 5.37362 0.00186157 12.0001C0.00186157 18.6265 5.37366 23.9983 12.0001 23.9983Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.60925 6.00088C1.06769 6.93877 0.668213 7.91933 0.402191 8.91811L20.4678 20.5031C21.1998 19.7733 21.8493 18.937 22.3908 17.9991L1.60925 6.00088Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.9991 1.60921C13.1983 -1.16252 7.27879 -0.238738 3.53214 3.4969L23.5978 15.0818C24.9597 9.9694 22.7999 4.38098 17.9991 1.60921Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.00092 22.3908C10.8017 25.1625 16.7213 24.2387 20.4679 20.5031L0.402184 8.91813C-0.959612 14.0307 1.20006 19.6191 6.00092 22.3908Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.3908 10.6958C15.3908 12.5685 13.8727 14.0867 12 14.0867C10.1273 14.0867 8.60919 12.5685 8.60919 10.6958C8.60919 10.112 8.7568 9.56252 9.01678 9.08284C8.28097 9.83534 7.82669 10.8644 7.82669 12C7.82669 14.3048 9.69512 16.1733 12 16.1733C14.3049 16.1733 16.1733 14.3049 16.1733 12C16.1733 10.8644 15.7191 9.83534 14.9832 9.08284C15.2432 9.56261 15.3908 10.112 15.3908 10.6958Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2176 6.78343H12.7826V14.6084H11.2176V6.78343Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6083 8.34838H9.39172C9.39172 8.70853 9.70546 9.00047 10.0656 9.00047H10.0438C10.0438 9.36062 10.3358 9.65257 10.6959 9.65257C10.6959 10.0127 10.9879 10.3047 11.348 10.3047H12.6521C13.0123 10.3047 13.3042 10.0127 13.3042 9.65257C13.6644 9.65257 13.9563 9.36062 13.9563 9.00047H13.9346C14.2946 9.00043 14.6083 8.70858 14.6083 8.34838Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.34845 15.13H15.6517V16.695H8.34845V15.13Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5651 15.6517H16.695V17.2167H13.5651V15.6517Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.30515 15.6517H10.4351V17.2167H7.30515V15.6517Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_663",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBrunei;
